import { defineComponent as _defineComponent } from 'vue'

const __default__ = {
  name: 'TextFieldWithSubmitButton',
  inheritAttrs: false,
}

import { computed, ref } from 'vue'
import { NcTextField } from '@nextcloud/vue'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    hint: { default: '' },
    value: { default: null },
    flexContainerClasses: { default: () => ['flex-justify-left', 'flex-align-start'] },
    flexItemClasses: { default: () => ['flex-justify-left', 'flex-align-start'] }
  },
  setup(__props: any) {

const props = __props as { hint: string, value: string|number|null, flexContainerClasses: string[], flexItemClasses: string[] };



const ncTextField = ref<typeof NcTextField|null>(null)

const ncTextFieldValue = computed<string|number>(() => ncTextField.value ? ncTextField.value.value : '')

return { __sfc: true,props, ncTextField, ncTextFieldValue, NcTextField }
}

})